'use client'

import { ActionCard } from '@dynamo-caffeina-dev/airc-ui-kit'
import { ActionCardProps } from '@/types'
import { dispatchGTMEvent } from '@/lib/tracking/gtm'
import { GTM_EVENT_CATEGORY } from '@/lib/tracking/types/GTM_EVENT_CATEGORY'
import toast from 'react-hot-toast'

// The `type` field is there, I don't know why TS won't see it
// @ts-ignore
type ActionType = ActionCardProps['action']['type']

interface ActionContent {
  title: string
  body: string
  navigate: ActionType
  url: string
}

export interface ActionClusterProps {
  items: {
    content: ActionContent
  }[]
}

function mapActionToIcon(action: ActionType) {
  switch (action) {
    case 'navigate':
      return 'ArrowTopRight'

    case 'call':
      return 'Phone'

    case 'copy':
      return 'Copy'

    default:
      return undefined
  }
}

const ActionCluster = ({ items }: ActionClusterProps) => {
  return (
    <div className='action-cluster'>
      {items.map(({ content }) => {
        const type = content.navigate

        let actionHandler

        // Use this to pass a custom handler to the action button;
        switch (type) {
          case 'copy':
            actionHandler = async function () {
              dispatchGTMEvent(GTM_EVENT_CATEGORY.SUPPORT_US, {
                cta_click: content.title,
              })

              if (typeof window !== 'undefined') {
                try {
                  await navigator.clipboard.writeText(content.body)

                  toast.success(`"${content.body}" copiato negli appunti!`)
                } catch (e) {
                  toast.error('Impossibile copiare')
                }
              }
            }

            break

          case 'call':
          case 'navigate':
          default:
            actionHandler = () => {
              dispatchGTMEvent(GTM_EVENT_CATEGORY.SUPPORT_US, {
                cta_click: content.title,
              })
            }
        }

        return (
          <ActionCard
            key={content.title}
            title={content.title}
            body={content.body}
            action={{
              type,
              // We can let the icon be falsy, it will be handled
              icon: mapActionToIcon(type)!,
              url: content.url,
            }}
            actionHandler={actionHandler}
          />
        )
      })}
    </div>
  )
}

export default ActionCluster
